import * as React from 'react'
const QuestionIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M10 16a.87.87 0 00-.9.6.64.64 0 000 .6.55.55 0 00.3.5 2.19 2.19 0 00.5.3.64.64 0 00.6 0 .78.78 0 00.4-.4 1.69 1.69 0 00.2-.5.91.91 0 00-.3-.7.91.91 0 00-.8-.4zM10 2a5.12 5.12 0 00-5.1 5.1.65.65 0 00.6.6.65.65 0 00.6-.6 3.9 3.9 0 117.8-.2 4 4 0 01-3.8 4H10a.52.52 0 00-.4.2.76.76 0 00-.2.4v1.9a.52.52 0 00.2.4.76.76 0 00.4.2.65.65 0 00.6-.6v-1.3a5.3 5.3 0 003.3-1.7 5.09 5.09 0 00-.7-7.2A4.72 4.72 0 0010 2z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default QuestionIcon